import { VTextarea } from 'vuetify/lib'
import { defaultFun, makeSlots } from '../utils'
import { TEXTAREAS_FIELD } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: TEXTAREAS_FIELD,
    mixins: [ commonMixins ],
    computed: {
        myScopedSlots() {
            const {scopedSlots = {}} = this.field
            return Object.keys(scopedSlots).reduce((total, key) => {
                if (scopedSlots[key] instanceof Function && key !== '_normalized') {
                    total[key] = makeSlots(scopedSlots[key])
                }
                total[key] = makeSlots(scopedSlots[key])
                 return total
             }, {})
        }
    },
    render(h) {
        const {
             key,
             _type = 'text',
             rows = 2,
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             'click:clear': click_clear = defaultFun,
             'click:append': click_append = defaultFun,
             'keydown.enter': keydown_enter = defaultFun,
             // eslint-disable-next-line 
             slots,scopedSlots,
             ...params 
            } = this.field
        params.type = _type
        params.value = this.my_value[key]
        params.rows = rows
        const {_normalized, ...otehrmyScopedSlots} = this.myScopedSlots
        return h(VTextarea, {
            props: params,
            slots: this.$slots,
            scopedSlots:otehrmyScopedSlots,
            on: {
                'click:clear':(data) => {
                    click_clear(data)
                },
                'click:append': (data) => {
                    click_append(data)
                },
                keydown: (data) => {
                    const key = data.key.toLowerCase()
                    switch (key) {
                        case 'enter':
                            keydown_enter(data)
                            break;
                        default:
                            break;
                    }
                    keydown()
                },
                blur,
                change,
                click,
                focus,
                input:(data) => {
                    this.my_value[key] = data
                    input(data)
                },
                mousedown,
                mouseup
            }
        })
    }
}